var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"dropdown-item",attrs:{"type":"button"},on:{"click":_vm.deleteCandidate}},[_c('i',{staticClass:"fas fa-times"}),_vm._v(" "+_vm._s(_vm.$t('Delete'))+"\n  ")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f7a6adc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Job/JobMassiveAction/JobMassiveActionDelete.vue
// module id = null
// module chunks = 